// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2TN8o","colMin":"styles_colMin__2MULK","colCheckbox":"styles_colCheckbox__1UKf-"};